import { isDirty } from "@frui.ts/dirtycheck";
import { observable } from "mobx";
import type { EntityValidationRules } from "../../services/validationService";

export default class ChargeOrderSearchFilter {
  @observable orderIdent?: number;
  @observable countryId?: string;
  @observable licensePlate?: string;
  @observable orderStatus?: string;
  @observable orderCreatedDate?: Date;
  @observable validFor?: string;
  @observable validSinceDate?: Date;
  @observable validUntilDate?: Date;
  @observable phoneNumber?: string;
  @observable email?: string;
  @observable paymentType?: string;
  @observable paidAmount?: number;
  @observable sourceType?: string;
  @observable fullTextSearchEnabled = false;
}

export const ChargeOrderSearchFilterValidationRules: EntityValidationRules<ChargeOrderSearchFilter> = {
  licensePlate: {
    isLength: {
      min: 1,
      optional: true,
    },
    isLicensePlate: {
      required: false,
    },
    requiredIf: {
      condition: (entity: ChargeOrderSearchFilter) => {
        return isDirty(entity) && !entity.orderIdent && !entity.email && !entity.phoneNumber;
      },
      customMessage: "oneOfLicensePlateOrderIdentEmailPhoneNumber",
    },
  },
  orderIdent: {
    range: { min: 1000000001, max: 9999999999, optional: true },
    requiredIf: {
      condition: (entity: ChargeOrderSearchFilter) => {
        return isDirty(entity) && !entity.licensePlate && !entity.email && !entity.phoneNumber;
      },
      customMessage: "oneOfLicensePlateOrderIdentEmailPhoneNumber",
    },
  },
  email: {
    isLength: {
      min: 3,
      optional: true,
    },
    requiredIf: {
      condition: (entity: ChargeOrderSearchFilter) => {
        return isDirty(entity) && !entity.licensePlate && !entity.orderIdent && !entity.phoneNumber;
      },
      customMessage: "oneOfLicensePlateOrderIdentEmailPhoneNumber",
    },
  },
  phoneNumber: {
    isLength: {
      min: 3,
      optional: true,
    },
    requiredIf: {
      condition: (entity: ChargeOrderSearchFilter) => {
        return isDirty(entity) && !entity.licensePlate && !entity.orderIdent && !entity.email;
      },
      customMessage: "oneOfLicensePlateOrderIdentEmailPhoneNumber",
    },
  },
};
